import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

class SearchInput extends Component {

    onFilterChange(e) {
        const search = e.target.value;
        const { stores } = this.props;

        stores.ui.view.replacePage(null, {
            ...stores.ui.view.parameters,
            search: search,
        });

        if (this.props.onFilterChange) {
            this.props.onFilterChange(e);
        }
    }

    render() {

        const { stores } = this.props;

        const { search } = stores.ui.view.parameters;

        return (
            <input placeholder="Filter" className="form-control" value={search} onChange={this.onFilterChange.bind(this)} />
        );
    }
}

export default inject("stores")(observer(SearchInput));


// WEBPACK FOOTER //
// ./src/Components/SearchInput.js